/* JUNGCARDS motion layer: hero slider, scroll reveals, add-to-cart feedback.
   Everything here is progressive: without this file the page is fully usable. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.jcMotionReady = true;

  /* ---- Hero slider (native scroll-snap, so swipe works without JS) ---- */
  if (!customElements.get('jc-slider')) {
    customElements.define(
      'jc-slider',
      class JcSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
          this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
          this.index = 0;
          if (!this.track || this.slides.length < 2) return;

          var self = this;
          var prev = this.querySelector('[data-prev]');
          var next = this.querySelector('[data-next]');
          if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
          if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
          this.dots.forEach(function (dot, i) {
            dot.addEventListener('click', function () { self.goTo(i); });
          });

          if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (entry.isIntersecting) self.setActive(self.slides.indexOf(entry.target));
                });
              },
              { root: this.track, threshold: 0.6 }
            );
            this.slides.forEach(function (slide) { observer.observe(slide); });
          }

          this.paused = false;
          ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
            self.addEventListener(type, function () {
              self.paused = true;
              self.classList.add('is-held');
            }, { passive: true });
          });
          ['pointerleave', 'focusout'].forEach(function (type) {
            self.addEventListener(type, function () {
              if (!self.paused) return;
              self.paused = false;
              self.classList.remove('is-held');
              // Resume with a full interval so the progress dot and the timer stay in sync.
              if (!self.stopped) self.start();
            });
          });

          this.speed = (parseInt(this.dataset.speed, 10) || 7) * 1000;
          this.style.setProperty('--jc-speed', this.speed + 'ms');
          this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion && !(window.Shopify && Shopify.designMode);
          this.classList.toggle('is-autoplay', this.autoplay);
          this.pauseButton = this.querySelector('[data-pause]');
          if (this.pauseButton) {
            if (!this.autoplay) this.pauseButton.hidden = true;
            this.pauseButton.addEventListener('click', function () {
              self.stopped = !self.stopped;
              self.pauseButton.classList.toggle('is-paused', self.stopped);
              self.pauseButton.setAttribute('aria-label', self.stopped ? self.pauseButton.dataset.labelPlay : self.pauseButton.dataset.labelPause);
              self.classList.toggle('is-stopped', self.stopped);
              if (self.stopped) self.stop(); else self.start();
            });
          }
          this.setActive(0);
          this.start();

          /* theme editor: show the slide whose block is selected */
          this.addEventListener('shopify:block:select', function (event) {
            var i = self.slides.indexOf(event.target);
            if (i > -1) self.goTo(i);
          });
        }

        start() {
          var self = this;
          this.stop();
          if (!this.autoplay || this.stopped) return;
          this.restartProgress();
          this.timer = setInterval(function () {
            if (self.paused || document.hidden) return;
            self.goTo(self.index + 1, true);
          }, this.speed);
        }

        stop() {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
        }

        /* Restart the active dot's fill animation (CSS) together with the timer. */
        restartProgress() {
          var dot = this.dots[this.index || 0];
          if (!dot || dot.getAttribute('aria-current') !== 'true') return;
          dot.removeAttribute('aria-current');
          void dot.offsetWidth;
          dot.setAttribute('aria-current', 'true');
        }

        disconnectedCallback() {
          this.stop();
        }

        goTo(i, fromTimer) {
          if (!fromTimer) this.start();
          var count = this.slides.length;
          var target = ((i % count) + count) % count;
          this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        setActive(i) {
          if (i < 0) return;
          this.index = i;
          this.slides.forEach(function (slide, n) {
            slide.classList.toggle('is-active', n === i);
            slide.inert = n !== i;
          });
          this.dots.forEach(function (dot, n) {
            if (n === i) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  /* ---- Scroll reveal: fire once per section, stagger list children ---- */
  function initReveal() {
    var sections = document.querySelectorAll('.jc-section');
    if (!sections.length) return;
    sections.forEach(function (section) {
      section.querySelectorAll('.jc-grid > li, .jc-tiles > li, .jc-cats > li, .jc-trust > li').forEach(function (item) {
        var index = Array.prototype.indexOf.call(item.parentNode.children, item);
        item.style.setProperty('--jc-i', Math.min(index, 5));
      });
    });
    if (!('IntersectionObserver' in window) || reduceMotion) {
      sections.forEach(function (section) { section.classList.add('is-in'); });
      return;
    }
    // Read all positions first, then write: sections already on screen stay as rendered.
    var fold = window.innerHeight;
    var below = Array.prototype.filter.call(sections, function (section) {
      return section.getBoundingClientRect().top > fold;
    });
    below.forEach(function (section) { section.classList.add('jc-reveal'); });
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -80px 0px' }
    );
    below.forEach(function (section) { observer.observe(section); });
  }

  /* ---- Add-to-cart feedback on product cards ---- */
  function initCardFeedback() {
    var lastButton = null;
    document.addEventListener(
      'submit',
      function (event) {
        var quick = event.target.closest ? event.target.closest('.jc-card__quick') : null;
        if (quick) lastButton = quick.querySelector('.jc-card__add');
      },
      true
    );
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartError) {
      subscribe(PUB_SUB_EVENTS.cartError, function () { lastButton = null; });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!lastButton || !event || event.source !== 'product-form') return;
        var button = lastButton;
        lastButton = null;
        button.classList.add('is-added');
        setTimeout(function () { button.classList.remove('is-added'); }, 1400);
      });
    }
  }

  /* ---- Mobile sticky add-to-cart: show once the main buy button has scrolled away ---- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-jc-sticky-atc]');
    var mainButton = document.querySelector('product-info .product-form__submit');
    if (!bar || !mainButton) return;
    bar.hidden = false;
    var ticking = false;
    function update() {
      ticking = false;
      var rect = mainButton.getBoundingClientRect();
      /* show while the main button is out of sight (below the first screen or scrolled away), so a
         buy button is always on screen; the bar takes the bottom nav's place (jc-polish.css) and
         hides as soon as the main button is visible above it */
      var covered = bar.offsetHeight + 24;
      var visible = rect.bottom < 0 || rect.top > window.innerHeight - covered;
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
    bar.querySelector('[data-jc-sticky-add]').addEventListener('click', function () {
      mainButton.click();
    });
  }

  /*
   * Mobile: no cart drawer. The cart icon goes straight to the cart page and an add to cart
   * shows a short confirmation toast instead of opening the drawer.
   */
  function initMobileCart() {
    var mobile = window.matchMedia('(max-width: 749px)');
    var toast = document.querySelector('[data-jc-toast]');
    var timer;
    function showToast() {
      // The "added" sheet (jc-added.js) replaces the toast on phones when it is switched on.
      if (!toast || (window.jcAddedActive && window.jcAddedActive())) return;
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(timer);
      timer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.hidden = true; }, 250);
      }, 4000);
    }
    function patch() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var proto = Object.getPrototypeOf(drawer);
      if (!proto || !proto.open || proto.jcMobilePatched) return;
      proto.jcMobilePatched = true;
      var originalOpen = proto.open;
      proto.open = function (triggeredBy) {
        if (!mobile.matches) return originalOpen.apply(this, arguments);
        if (triggeredBy) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        else showToast();
      };
    }
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(patch);
  }

  /* ---- Collection description: clamp long SEO text, keep it in the DOM ---- */
  function initClamp() {
    document.querySelectorAll('[data-jc-clamp]').forEach(function (box) {
      // The clamp is rendered server-side (no layout shift); the script only opens it.
      var toggle = box.parentNode.querySelector('[data-jc-clamp-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        box.classList.remove('is-clamped');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.hidden = true;
      });
    });
  }

  /* ---- Cart drawer: Enter in a quantity field updates the quantity instead of going to checkout ---- */
  function initDrawerEnter() {
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
      if (!input.closest('cart-drawer')) return;
      event.preventDefault();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---- Errors from quick add / add-ons (e.g. "only 1 left") were silent: show them ---- */
  function initCartErrors() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object' || !PUB_SUB_EVENTS.cartError) return;
    var box = document.querySelector('[data-jc-error-toast]');
    var timer;
    if (!box) return;
    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      var message = event && ((typeof event.errors === 'string' && event.errors) || event.message);
      if (!message) return;
      box.textContent = message;
      box.classList.add('is-visible');
      clearTimeout(timer);
      timer = setTimeout(function () { box.classList.remove('is-visible'); }, 5000);
    });
  }

  /* ---- Chat links: open the Shopify Inbox launcher (hidden on small product/cart screens) ---- */
  function initChatLinks() {
    var links = document.querySelectorAll('[data-jc-chat]');
    if (!links.length) return;
    /* The Shopify Inbox launcher sits in nested shadow roots (shopify-chat > shopify-agent-runtime);
       it is the first button that reports aria-expanded. */
    function launcher() {
      var host = document.querySelector('shopify-chat');
      if (!host || !host.shadowRoot) return null;
      var queue = [host.shadowRoot];
      while (queue.length) {
        var root = queue.shift();
        var button = root.querySelector('button[aria-expanded]');
        if (button) return button;
        root.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) queue.push(el.shadowRoot); });
      }
      return null;
    }
    /* Phones hide the floating launcher (CSS); keep the chat visible while its window is open. */
    var watched = null;
    function watchOpenState() {
      var button = launcher();
      if (!button || button === watched) return;
      watched = button;
      var sync = function () {
        document.documentElement.classList.toggle('jc-chat-open', button.getAttribute('aria-expanded') === 'true');
      };
      new MutationObserver(sync).observe(button, { attributes: true, attributeFilter: ['aria-expanded'] });
      sync();
    }
    function reveal() {
      if (!launcher()) return false;
      links.forEach(function (link) { link.hidden = false; });
      watchOpenState();
      return true;
    }
    /* the chat app loads late; only show the links once it is there */
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (reveal() || tries > 20) clearInterval(timer);
    }, 1000);
    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('[data-jc-chat]') : null;
      if (!link) return;
      var drawer = link.closest('details[open]');
      if (drawer) drawer.querySelector('summary').click();
      var button = launcher();
      if (!button) return;
      watchOpenState();
      // Show the host first (hidden on phones and while the menu is open), then open the chat
      // window once the menu drawer has closed.
      document.documentElement.classList.add('jc-chat-open');
      setTimeout(function () {
        if (button.getAttribute('aria-expanded') !== 'true') button.click();
      }, drawer ? 450 : 0);
    });
  }

  /* ---- Empty search page (bottom-nav "Suche"): put the cursor in the field ---- */
  function initSearchFocus() {
    if (window.location.pathname.indexOf('/search') === -1) return;
    if (/[?&]q=[^&]/.test(window.location.search)) return;
    var field = document.getElementById('Search-In-Template');
    if (field) field.focus({ preventScroll: true });
  }

  /* ---- Offer strip: scroll to the newsletter form on the page and focus it ---- */
  function initNewsletterLink() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('[data-jc-newsletter-link]') : null;
      if (!link) return;
      var field = document.querySelector('input[id^="NewsletterForm--"]');
      if (!field) return;
      event.preventDefault();
      field.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { field.focus({ preventScroll: true }); }, reduceMotion ? 0 : 500);
    });
  }

  /* ---- Price in the main add-to-cart button follows the selected variant ---- */
  function initAtcPrice() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object' || !PUB_SUB_EVENTS.variantChange) return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;
      var id = 'ProductSubmitButton-' + data.sectionId;
      var current = document.getElementById(id);
      var next = data.html.getElementById(id);
      var currentPrice = current && current.querySelector('[data-jc-atc-price]');
      var nextPrice = next && next.querySelector('[data-jc-atc-price]');
      if (!currentPrice || !nextPrice) return;
      currentPrice.textContent = nextPrice.textContent;
      currentPrice.hidden = nextPrice.hidden;
      var sticky = document.querySelector('[data-jc-sticky-atc] .jc-sticky-atc__price');
      if (sticky && !nextPrice.hidden) sticky.textContent = nextPrice.textContent.trim();
    });
  }

  /*
   * ---- Product description: "Label: value" lists as a spec table ----
   * Product texts list their facts as bullets ("Inhalt: 100 Hüllen", "Größe: …"). A list where
   * every item has that shape becomes a two-column table (conversion research: Dragon Shield's
   * spec grid). The text stays the same; lists of any other shape are left alone.
   */
  function initSpecs() {
    document.querySelectorAll('.product__description ul').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      if (items.length < 3) return;
      var rows = [];
      for (var i = 0; i < items.length; i++) {
        var li = items[i];
        var match = li.textContent.trim().match(/^([^:\n]{2,24}):\s*([\s\S]+)$/);
        if (li.tagName !== 'LI' || !match) return;
        rows.push({ li: li, label: match[1].trim() });
      }
      var dl = document.createElement('dl');
      dl.className = 'jc-specs';
      rows.forEach(function (row) {
        var wrap = document.createElement('div');
        wrap.className = 'jc-specs__row';
        var dt = document.createElement('dt');
        dt.textContent = row.label;
        var dd = document.createElement('dd');
        // Keep the value's markup (bold parts, links): move the nodes after the label.
        var clone = row.li.cloneNode(true);
        var walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          var idx = node.nodeValue.indexOf(':');
          if (idx !== -1) {
            node.nodeValue = node.nodeValue.slice(idx + 1).replace(/^\s+/, '');
            var prev = node.previousSibling;
            while (prev) {
              var before = prev.previousSibling;
              prev.parentNode.removeChild(prev);
              prev = before;
            }
            break;
          }
        }
        while (clone.firstChild) dd.appendChild(clone.firstChild);
        wrap.appendChild(dt);
        wrap.appendChild(dd);
        dl.appendChild(wrap);
      });
      list.replaceWith(dl);
    });
  }

  /* ---- Order total in the checkout buttons (cart page footer is not re-rendered by Dawn) ---- */
  function initCheckoutTotal() {
    if (!document.querySelector('[data-jc-checkout-total]')) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object' || !PUB_SUB_EVENTS.cartUpdate) return;
    function render(cart) {
      if (!cart || typeof cart.total_price !== 'number') return;
      // Keep the shop's money format (e.g. "€34,99"): only the number part is replaced.
      var number;
      try {
        number = new Intl.NumberFormat(document.documentElement.lang || undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cart.total_price / 100);
      } catch (e) {
        number = (cart.total_price / 100).toFixed(2);
      }
      document.querySelectorAll('[data-jc-checkout-total]').forEach(function (el) {
        var current = el.textContent.trim();
        el.textContent = /\d/.test(current) ? current.replace(/\d[\d.,\s\u00a0\u202f]*\d|\d/, number) : number;
        el.hidden = cart.item_count === 0;
      });
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (data && typeof data.item_count === 'number' && data.currency) return render(data);
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var request = window.jcGetCart ? window.jcGetCart() : fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      request.then(render).catch(function () {});
    });
  }

  /* ---- Copy buttons on JungcardsHQ pages (review / referral / wheel confirm, app proxy):
     <button data-jc-copy="CODE" data-jc-copied="Kopiert">Kopieren</button> ---- */
  function initCopyButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-jc-copy]');
      if (!button || !navigator.clipboard) return;
      var label = button.textContent;
      navigator.clipboard.writeText(button.getAttribute('data-jc-copy')).then(function () {
        button.textContent = button.getAttribute('data-jc-copied') || '✓';
        setTimeout(function () { button.textContent = label; }, 1800);
      }, function () {});
    });
  }

  function init() {
    initReveal();
    initAtcPrice();
    initCheckoutTotal();
    initSpecs();
    initCardFeedback();
    initStickyAtc();
    initMobileCart();
    initClamp();
    initDrawerEnter();
    initCartErrors();
    initChatLinks();
    initSearchFocus();
    initNewsletterLink();
    initCopyButtons();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.jc-section').forEach(function (section) { section.classList.add('is-in'); });
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
